
import { Module } from '../core';

import doSearch from './commands/doSearch';

import MapCommandAddPins from './MapCommandAddPins';

import IMG_PIN_BLUE from '../assets/img/blue-pushpin.png';
import IMG_PIN_RED from '../assets/img/red-pushpin.png';

export default class ModuleSearch extends Module {

    constructor() {
        super('search');
    }

    addCommands(mapCommander) {
        mapCommander.addCommand(new MapCommandAddPins());
    }

    createLayerPins(olMap) {
        this._layerPins = olMap.createLayer({
            id: 'search_pins',
            type: 'Vector',
            style: {
                default: {
                    type: 'icon',
                    anchor: [0.35, 0.95],
                    src: IMG_PIN_BLUE
                },
                highlight: {
                    type: 'icon',
                    anchor: [0.35, 0.95],
                    src: IMG_PIN_RED
                }
            }
        });

        olMap.getMap().addLayer(this._layerPins);
    }

    initCommands() {
        this.addCommand(doSearch);
    }

    initOpenLayersMap(params) {
        this.createLayerPins(params.olMap);
        this.addCommands(params.mapCommander);
    }
}
